<template>
	<table class="table table-striped table-bordered">
		<thead>
			<tr>
				<th>Usuário</th>
				<th>Situação</th>
				<th width="15%">Data</th>
				<th>Observação</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="(item, index) in $props.solicitacao
					.solicitacao_historicos" :key="index">
				<td>{{ item.usuario.name }}</td>
				<td>{{ item.situacao | situacaoSolicitacao }}</td>
				<td>{{ item.created_at | dataHoraFormatada }}</td>
				<td style="text-transform: none">{{ item.observacao }}</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
	export default {
		props: ['solicitacao'],
		data: () => ({

		}),
		mounted() {

		},
		methods: {

		},
		watch: {

		},
		components: {

		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// solicitacaoHistorico.vue?72b2c934